/*
 * Copyright 2022-2026. NXGN Management, LLC. All Rights Reserved.
 */

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule } from "@angular/router";
import { GeneralInfoComponent } from "./general-info/general-info.component";
import { PaymentProcessorInfoComponent } from "./payment-processor-info/payment-processor-info.component";
import { CustomerContactComponent } from "./customer-contact/customer-contact.component";
import { MerchantDetailsParentComponent } from "./merchant-details-parent.component";
import { MatTabsModule } from "@angular/material/tabs";
import { LoadSpinnerModule } from "../load-spinner/load-spinner.module";
import { MerchantAddressComponent } from "./merchant-address/merchant-address.component";
import { LegalEntityComponent } from "./legal-entity/legal-entity.component";
import { BeneficialOwnerComponent } from "./beneficial-owner/beneficial-owner.component";
import { StateAbrrToNamePipe } from "../../pipes/state-abrr-to-name.pipe";
import { AcceptedCreditCardsComponent } from "./accepted-credit-cards/accepted-credit-cards.component";
import { AccountDetailsComponent } from "./account-details/account-details.component";
import { AccountTypeLabelPipe } from "../../pipes/account-type-label.pipe";
import { DepositTypeLabelPipe } from "../../pipes/deposite-type-label.pipe";
import { PayPalDetailsComponent } from "./pay-pal-details/pay-pal-details.component";
import { QBPayDetailsComponent } from "./qbpay-details/qbpay-details.component";
import { InstamedDetailsComponent } from "./instamed-details/instamed-details.component";
import { EStatementOptionsComponent } from "./e-statement-options/e-statement-options.component";
import { ReactiveFormsModule } from "@angular/forms";
import { UsersAndRolesComponent } from "./users-and-roles/users-and-roles.component";
import { RoleLabelPipe } from "../../pipes/role-label.pipe";
import { RatesAndContractComponent } from "./rates-and-contract/rates-and-contract.component";
import { PartnersComponent } from "./partners/partners.component";
import { ChargebacksComponent } from "./chargebacks/chargebacks.component";
import { FraudAndRiskComponent } from "./fraud-and-risk/fraud-and-risk.component";
import { CustomerContactEditComponent } from "./customer-contact/customer-contact-edit/customerContactEdit.component";
import { WpCustomerContactComponent } from "./customer-contact/wp-customer-contact/wp-customer-contact.component";
import { GeneralInfoEditComponent } from "./general-info/general-info-edit/general-info-edit.component";
import { WpGeneralInfoComponent } from "./general-info/wp-general-info/wp-general-info.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { WpMerchantAddressComponent } from "./merchant-address/wp-merchant-address/wp-merchant-address.component";
import { MerchantAddressEditComponent } from "./merchant-address/merchant-address-edit/merchant-address-edit.component";
import { LegalEntityEditComponent } from "./legal-entity/legal-entity-edit/legal-entity-edit.component";
import { WpLegalEntityComponent } from "./legal-entity/wp-legal-entity/wp-legal-entity.component";
import { AcceptedCreditCardsEditComponent } from "./accepted-credit-cards/accepted-credit-cards-edit/accepted-credit-cards-edit.component";
import { WpAcceptedCreditCardsComponent } from "./accepted-credit-cards/wp-accepted-credit-cards/wp-accepted-credit-cards.component";
import { AccountDetailsEditComponent } from "./account-details/account-details-edit/account-details-edit.component";
import { AddEditUserComponent } from "./users-and-roles/add-edit-user/add-edit-user.component";
import { EditEStatementOptionsComponent } from "./e-statement-options/edit-e-statement-opitons/edit-e-statement-options.component";
import { UploadLogoModalComponent } from "./e-statement-options/upload-logo-modal/upload-logo-modal.component";
import { BeneficialOwnerEditComponent } from "./beneficial-owner/beneficial-owner-edit/beneficial-owner-edit.component";
import { PayPalQbpayMerchantDetailsComponent } from "./general-info/payPal-qbpay-merchant-details/payPal-qbpay-merchant-details.component";
import { PayPalDetailEditComponent } from "./pay-pal-details/pay-pal-detail-edit/pay-pal-detail-edit.component";
import { InstamedDetailsEditComponent } from "./instamed-details/instamed-details-edit/instamed-details-edit.component";
import { GlobalPaymentsDetailsEditComponent } from "./global-payments-details/global-payments-details-edit/global-payments-details-edit.component";
import { GlobalPaymentsDetailsComponent } from "./global-payments-details/global-payments-details.component";
import { PaymentProcessorGeneralInfoComponent } from "./general-info/payment-processor-general-info/payment-processor-general-info.component";
import { EditRatesAndContractComponent } from "./rates-and-contract/edit-rates-and-contract/edit-rates-and-contract.component";
import { EditButtonsComponent } from "../edit-buttons/edit-buttons.component";
import { ActionModalModule } from "../action-modal/action-modal.module";
import { AddEditPartnersComponent } from "./partners/add-edit-partners/add-edit-partners.component";
import { CollectChargebacksComponent } from "./chargebacks/collect-chargebacks/collect-chargebacks.component";
import { FraudAndRiskEditComponent } from "./fraud-and-risk/fraud-and-risk-edit/fraud-and-risk-edit.component";
import { EditQbpayDetailsComponent } from "./qbpay-details/edit-qbpay-details/edit-qbpay-details.component";
import { CreateMerchantComponent } from "./create-merchant/create-merchant.component";
import { CollectChargebackModalComponent } from "./chargebacks/collect-chargeback-modal/collect-chargeback-modal.component";
import { ConfirmationModalComponent } from "./create-merchant/confirmation-modal/confirmation-modal.component";
import { TokenConversionConfirmationModelComponent } from "./general-info/general-info-edit/token-conversion-confirmation-model/token-conversion-confirmation-model.component";
import { ConfirmationDialogModule } from "../confirmation-dialog/confirmation-dialog.module";

@NgModule({
  declarations: [
    GeneralInfoComponent,
    PaymentProcessorInfoComponent,
    CustomerContactComponent,
    MerchantDetailsParentComponent,
    MerchantAddressComponent,
    LegalEntityComponent,
    BeneficialOwnerComponent,
    StateAbrrToNamePipe,
    AcceptedCreditCardsComponent,
    AccountDetailsComponent,
    AccountTypeLabelPipe,
    DepositTypeLabelPipe,
    PayPalDetailsComponent,
    QBPayDetailsComponent,
    InstamedDetailsComponent,
    EStatementOptionsComponent,
    UsersAndRolesComponent,
    RoleLabelPipe,
    RatesAndContractComponent,
    PartnersComponent,
    ChargebacksComponent,
    FraudAndRiskComponent,
    CustomerContactEditComponent,
    WpCustomerContactComponent,
    GeneralInfoEditComponent,
    WpGeneralInfoComponent,
    WpMerchantAddressComponent,
    MerchantAddressEditComponent,
    LegalEntityEditComponent,
    WpLegalEntityComponent,
    AcceptedCreditCardsEditComponent,
    WpAcceptedCreditCardsComponent,
    AccountDetailsEditComponent,
    AddEditUserComponent,
    EditEStatementOptionsComponent,
    UploadLogoModalComponent,
    BeneficialOwnerEditComponent,
    PayPalQbpayMerchantDetailsComponent,
    PayPalDetailEditComponent,
    InstamedDetailsEditComponent,
    GlobalPaymentsDetailsEditComponent,
    GlobalPaymentsDetailsComponent,
    PaymentProcessorGeneralInfoComponent,
    EditRatesAndContractComponent,
    EditButtonsComponent,
    AddEditPartnersComponent,
    CollectChargebacksComponent,
    EditQbpayDetailsComponent,
    CreateMerchantComponent,
    FraudAndRiskEditComponent,
    CollectChargebackModalComponent,
    ConfirmationModalComponent,
    TokenConversionConfirmationModelComponent
  ],
  providers: [],
  imports: [
    CommonModule,
    FontAwesomeModule,
    RouterModule,
    MatTabsModule,
    LoadSpinnerModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    ActionModalModule,
    ConfirmationDialogModule
  ]
})
export class MerchantDetailsModule {}
